import { Component, inject, Inject } from '@angular/core';
import { PendingRequestsService } from '../services/pending-requests.service';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { SendToBankComponent } from '../send-to-bank/send-to-bank.component';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { IPaymentFileData } from '../models/payment-file-data.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-payment-file',
  standalone: true,
  imports: [MatDialogModule, MatTableModule, CommonModule, MatProgressSpinnerModule],
  templateUrl: './payment-file.component.html',
  styleUrl: './payment-file.component.scss'
})
export class PaymentFileComponent {
  requests: {requestNumber: number, title: string}[] = [];
  displayedColumns: string[] = ['number', 'request', 'employee', 'lineType', 'description', 'account', 'amount'];
  pendingRequestsService: PendingRequestsService = inject(PendingRequestsService);
  masterAccount: string;
  mainData: IPaymentFileData[] = [];
  loggedInUserService = inject(LoggedInUserService);
  processingInProgress: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {requests: {requestNumber: number, title: string}[]}, public dialogRef: MatDialogRef<SendToBankComponent>) { 
    this.requests = data.requests;
  }

  ngOnInit(): void {
    this.pendingRequestsService.getPaymentFileData(this.requests.map(request => request.requestNumber)).subscribe(
      (data) => {
        this.mainData = data;
        this.processingInProgress = false;
        
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  sendToExcel(): void {
    const dataToExport = this.mainData.map(({ result, ...rest }) => rest);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    XLSX.utils.book_append_sheet(wb, ws, 'payment-file');
    XLSX.writeFile(wb, 'payment-file.xlsx');
    this.dialogRef.close();
  }
}